import { TextField, Divider } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { ExternalLeadStore } from 'libs/client-portal-shared/src/app/modules/companyProfile/stores/externalLeadStore';
import { LEAD_OBJECT_TYPE } from '../leads/constants/constants';
import { CadenceStore } from 'libs/client-portal-shared/src/app/modules/companyProfile/stores/cadenceStore/cadenceStore';

interface IDashboardAutocompleteField {
  store: CadenceStore;
  isNotCrmDashboard?: boolean;
}

export const CadencesAutocompleteField = observer(({ store }: IDashboardAutocompleteField) => {
  const { currentDashboardId } = store;

  const onSelect = (opt) => {
    store.setCadenceOption(opt.value)
  }

  return (
    <Autocomplete
      id="leads-dashboard-autocomplete"
      selectOnFocus
      handleHomeEndKeys
      options={store.cadenceOptions}
      defaultValue={store.cadenceOptions.find(o => o.value === currentDashboardId) || {}}
      inputValue={store.searchText}
      size="small"
      blurOnSelect={true}
      onInputChange={(e, value) => (store.searchText = value)}
      renderInput={params => <TextField variant={'outlined'} {...params} />}
      getOptionLabel={option => option?.label ?? ''}
      getOptionSelected={(option, selected) => option?.value === selected?.value}
      onChange={(event, option) => onSelect(option)}
      placeholder={'Select cadence'}
      fullWidth
    />
  );
});
